const blocks = [
  {
    title: "O que é o New Braz?",
    text: "O New Braz é o melhor app P2P do Brasil para assistir TV online: milhares de canais ao vivo, filmes e séries em HD e 4K. Diferente do IPTV tradicional, a tecnologia P2P (peer-to-peer) distribui a transmissão entre servidores redundantes, eliminando travamentos mesmo em horários de pico, como jogos de futebol ao vivo. É a escolha de mais de 1.250 clientes ativos que avaliam o serviço com 4.8 estrelas.",
  },
  {
    title: "Como baixar o New Braz na Smart TV?",
    text: "Para baixar o app New Braz na sua Smart TV Samsung, LG, Android TV, TV Box ou Fire TV Stick é muito simples: instale o aplicativo \"Downloader\" pela loja oficial da sua TV, digite o código 857809 e o New Braz será baixado e instalado automaticamente. Também é possível baixar o arquivo newbraz.apk diretamente na seção de downloads ou solicitar o link pelo WhatsApp com ajuda da nossa equipe de suporte 24h.",
  },
  {
    title: "Qual o melhor app de IPTV e P2P em 2026?",
    text: "Entre os apps de TV mais buscados estão New Braz, New Hybrid, IBO Player, IPTV Smarters Pro, Dream TV, XCLOUD TV, Purple IPTV, ISP IPTV e VEJO V3. O New Braz se destaca como app oficial com tecnologia P2P integrada, gravação automática de 5 dias e interface moderna. Para Smart TVs Samsung e LG, o IBO Player e o Dream TV são excelentes alternativas; no celular Android, o New Braz e o VEJO V3 são os mais leves e rápidos.",
  },
  {
    title: "IPTV ou P2P: qual a diferença?",
    text: "No IPTV tradicional, cada usuário se conecta diretamente a um servidor central — quando muitos assistem ao mesmo tempo, ocorrem travamentos. Já no sistema P2P do New Braz, a transmissão é distribuída de forma inteligente, garantindo estabilidade, qualidade HD/4K constante e disponibilidade 24/7. Por isso quem migra de listas IPTV comuns para o New Braz percebe a diferença na primeira semana, especialmente em eventos esportivos ao vivo.",
  },
];

export const SeoContent = () => (
  <section data-testid="seo-content-section" className="py-20 px-4 sm:px-6 border-t border-white/10">
    <div className="max-w-4xl mx-auto">
      <p className="text-[#FF5A00] text-sm font-bold uppercase tracking-[0.25em] mb-3">Guia New Braz</p>
      <h2 className="text-2xl sm:text-3xl font-black tracking-tighter mb-10" style={{ fontFamily: "Outfit, sans-serif" }}>
        Tudo sobre app TV, P2P e IPTV no Brasil
      </h2>
      <div className="space-y-10">
        {blocks.map((b, i) => (
          <article key={i} data-testid={`seo-article-${i}`}>
            <h3 className="text-lg sm:text-xl font-bold mb-3 text-white/90" style={{ fontFamily: "Outfit, sans-serif" }}>
              {b.title}
            </h3>
            <p className="text-sm sm:text-base text-white/50 leading-relaxed">{b.text}</p>
          </article>
        ))}
      </div>
      <div className="mt-10 flex flex-wrap gap-3">
        <a href="#downloads" className="text-sm text-[#FF5A00] hover:text-[#FF7A33] font-semibold transition-colors">Baixar apps →</a>
        <a href="#planos" className="text-sm text-[#FF5A00] hover:text-[#FF7A33] font-semibold transition-colors">Ver planos →</a>
        <a href="#dispositivos" className="text-sm text-[#FF5A00] hover:text-[#FF7A33] font-semibold transition-colors">Dispositivos compatíveis →</a>
      </div>
    </div>
  </section>
);
